import React, { createContext, useContext, useEffect, useState } from "react";
import { Urls } from "./Urls";
import axios from "./Axios";
import { UserDataContext } from "./UserContext";
import { CompanyDetailsContext } from "./CompanyDetailsContext";

export const MyCompanyProfileContext = createContext({});

export const MyCompanyProfileDetailsProvider = ({ children }) => {
  const [companySettingData, setCompanySettingData] = useState({});
  const [isCompanyProfileLoading, setIsCompanyProfileLoading] = useState(false);
  const [companyName, companyID] = useContext(CompanyDetailsContext);

  const fetchCompanyProfileDetails = () => {
    setIsCompanyProfileLoading(true);
    axios
      .post(
        `${Urls.companyProfile}?company_id=${companyID}&projections_enable=true`,
        {
          projections: {
            indent: 1,
            contact_information: 1,
            masters_setting: 1,
            organizations: 1,
            approver_data: 1,
            enquiry: 1,
            vendor_groups: 1,
            default_currency: 1,
          },
        }
      )
      .then((res) => {
        if (res && res.data && res.data.length > 0) {
          setCompanySettingData(res?.data?.[0]);
        }
      })
      .catch((err) => {
        console.error(err, "error");
      })
      .finally(() => {
        setIsCompanyProfileLoading(false);
      });
  };

  useEffect(() => {
    if (companyID && companyID !== undefined) {
      fetchCompanyProfileDetails();
    }
  }, [companyID]);

  return (
    <MyCompanyProfileContext.Provider
      value={{
        companySettingData,
        fetchCompanyProfileDetails,
        isCompanyProfileLoading,
      }}
    >
      {children}
    </MyCompanyProfileContext.Provider>
  );
};

export function useCompany() {
  return useContext(MyCompanyProfileContext);
}
